var React = require('react');

function Report (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.46 6H16.54L6 16.54v14.91L16.54 42h14.91L42 31.46V16.54L31.46 6zM24 34.6c-1.43 0-2.6-1.16-2.6-2.6 0-1.43 1.17-2.6 2.6-2.6 1.43 0 2.6 1.16 2.6 2.6 0 1.44-1.17 2.6-2.6 2.6zm2-8.6h-4V14h4v12z"}));
}

Report.displayName = "Report";

Report.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Report;

Report.default = Report;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/report.svg